export const kmhToMs = (kmh: number): number => kmh / 3.6;
export const msToKmh = (ms: number): number => ms * 3.6;

/** 秒を「h:mm」に（所要時間の表示） */
export function formatDuration(seconds: number): string {
  const totalMin = Math.round(seconds / 60);
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  return `${h}:${String(m).padStart(2, '0')}`;
}

/** その日の 00:00 からの秒数を「hh:mm」に */
export function formatClock(timeOfDayS: number): string {
  const totalMin = Math.floor(timeOfDayS / 60);
  const h = Math.floor(totalMin / 60) % 24;
  const m = totalMin % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export function formatKm(meters: number, digits = 1): string {
  return `${(meters / 1000).toFixed(digits)}km`;
}
